/**
 * Test IDs for QA automation.
 */
export const testIds = {
  qualificationsListCurrentNavigation: "qualifications-list-current-navigation",
  qualificationsListCurrentView: "qualifications-list-current-view",
  qualificationsListExpired: "qualifications-list-expired",
  qualificationsListNewQualification: "qualifications-list-new-qualification",
} as const;
